import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Typography } from '@material-ui/core'
import noImage from 'assets/img/no-image.jpg'
import moment from 'moment'
import { ROUTES } from 'routes'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './ChampionshipSection.style'

const ChampionshipSection = () => {
  const classes = useStyles()

  const {
    event: { championship }
  } = useSelector((state) => state.events)

  const { imageUrl, name, slugUrl, from, to } = championship

  const fromLocal = moment(from)
  const toLocal = moment(to)

  const eventDateFormat = fromLocal.isSame(toLocal, 'years')
    ? fromLocal.format('YYYY')
    : `${fromLocal.format('YYYY')}/${toLocal.format('YYYY')}`

  return (
    <SectionBlock title='Campeonato'>
      <Link className={classes.content} to={`${ROUTES.CHAMPIONSHIPS.PROFILE}/${slugUrl}`}>
        <div className={classes.image} style={{ backgroundImage: `url(${imageUrl || noImage})` }} />
        <Typography className={classes.name} color='primary' title={`${name} (${eventDateFormat})`}>
          {`${name} (${eventDateFormat})`}
        </Typography>
      </Link>
    </SectionBlock>
  )
}

export default ChampionshipSection
